<template>
    <div id="project_manager_page" class="container-fluid">
        <v-client-table :data="tableData" :columns="columns" :options="options"></v-client-table>
    </div>
</template>

<script>
    export default {
        created() {
            this.fetchServerData();
        },
        data() {
            return {
                has_clients:false,
                columns: ['client_name', 'project_manager_name'],
                tableData: [],
                options: {
                    headings: {
                        client_name: 'Client Name',
                        project_manager_name:  'Project Manager Name'
                    },
                    sortable: ['client_name', 'project_manager_name'],
                    perPage: 20,
                    perPageValues: [],
                    texts: {
                        count: 'Showing {from} to {to} of {count} project managers|{count} project managers|One project manager',
                        filter: '',
                        filterPlaceholder: 'Search clients...',
                        noResults: 'No matching project managers'
                    },
                    skin: 'table'
                }
            }
        },
        methods: {
            fetchServerData() {
                axios.all([
                    axios.get('/api/clients?with_data=user'),
                    axios.get('/api/users/project_managers')
                ]).then(axios.spread((clients, project_managers) => {
                    this.tableData  = project_managers.data;
                    this.has_clients = clients.data.length;
                    this.loaded();
                }));
            },
            loaded(){
                setTimeout(function(){
                    $('div#project_manager_page').find('span.VueTables__sort-icon').addClass('project_manager_page');
                }, 200);
            }
        }
    }
</script>

<style lang="scss" scoped>
    #project_manager_page {
        .fa-trash-o {
            font-size: 1.4rem;
            padding: .1rem;
        }

        button:disabled{
            cursor: not-allowed;

            &:hover{
                color:white;
            }
        }
    }
</style>
<style>
    .VueTables__sort-icon.project_manager_page{
        margin-right:50% !important;
    }
</style>